/* eslint-disable no-console */
import { AuthProvider } from '@domain/authentication';
import { TranslateService } from '@ngx-translate/core';
import { ErrorCodes, FileModel, ToastDuration, ToastService, User } from '@shared';
import { LoggingService } from '@shared/logging';
import { IImportHandler } from '../import-handler.interface';

export class AuthenticationHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private loggingService: LoggingService,
		private toastService: ToastService,
		private translateService: TranslateService,
		private authProvider: AuthProvider
	) {}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		await this.checkFusionUsers(model);

		if (this.next) {
		await this.next.handle(model);
		}
	}

	private async checkFusionUsers(model: FileModel): Promise<void> {
		// validate fusion user access from manual import
		try {
			if (!model.FusionUsers || model.FusionUsers.length === 0) {
				throw new Error('No Fusion Users list found in the imported file');
			}

			const fusionUserId: string = await this.authProvider.getFusionUserId();
			const userHasAccess = model.FusionUsers.find((user: User) => user.userid === fusionUserId);

			if (!userHasAccess) {
				throw new Error('You do not have access to this file. Please import another one.');
			}
		} catch (error) {
			this.loggingService.error(ErrorCodes.FileValidatorHandlerFusionUserNoAccess, error);
			await this.toastService.presentError(
				this.translateService.instant('alert.import.validationMessages.userNoAccess'),
				ToastDuration.Slow
			);
			throw error;
		}
	}
}
